export default {
  'app.org.title': '全部組織',
  'app.org.column.id': '組織ID',
  'app.org.column.name': '組織名稱',
  'app.org.column.timezone': '時區',
  'app.org.column.website': '組織網址',
  'app.org.column.isCreator': '是否為建立者',
  'app.org.column.createTime': '建立時間',
  'app.org.column.operate': '操作',
  'app.org.column.operate.enter': '進入',
  'app.org.column.operate.edit': '編輯',
  'app.org.column.operate.delete': '刪除',
  'app.org.column.operate.placeholder': '請輸入組織名稱/組織ID',
  'app.org.create': '建立組織',
  'app.org.create.submit': '建立組織',
  'app.org.bind.tip': '創建新組織',
  'app.org.create.tip': '已有組織？',
  'app.org.create.tip.bind': '去綁定',
  'app.org.success.tip': '返回控制台',
  'app.org.bind': '綁定組織',
  'app.org.bind.submit': '完成綁定',
  'app.org.create.create': '建立',
  'app.org.create.save': '保存',
  'app.org.create.cancel': '取消',
  'app.org.create.profile': '組織資訊',
  'app.org.create.name.placeholder': '輸入組織名稱',
  'app.org.create.website.placeholder': '輸入網址包含（.頂級域名）',
  'app.org.create.timezone': '時區選擇',
  'app.org.create.timezone.tip': '（時區一旦選定，將無法更改）',
  'app.org.create.currency': '帳單幣種',
  'app.org.create.usd': '美元',
  'app.org.create.success': '創建成功',
  'app.org.edit.success': '編輯成功',
  'app.org.rule.blank': '內容不得為空',
  'app.org.rule.char': '角色名稱禁止輸入非法字符',
  'app.org.rule.name.exists': '組織名稱已存在',
  'app.org.rule.url.exists': '位址已存在',
  'app.org.rule.url.start': '請輸入 www 開頭網址',
  'app.org.delete.title': '刪除組織',
  'app.org.delete.content':
    '警告！刪除組織操作為不可逆轉，將永久刪除該組織內的用戶、業務、餘額、帳單、訂單和權益等資料和資訊，同時停止所有相關服務。',
  'app.org.delete.warn': '要刪除帳戶，該帳戶必須無待補繳的帳單，否則將無法刪除！',
  'app.org.delete.cancel': '取消',
  'app.org.delete.next': '下一步',
  'app.org.delete.delete': '刪除',
  'app.org.delete.confirm': '確認刪除組織',
  'app.org.delete.confirm.content':
    '您提交的刪除帳戶申請生效前，我們將進行下列驗證事宜，以確保您的帳號安全。請檢查電子郵件中的驗證碼資訊',
  'app.org.delete.confirm.send': '傳送驗證',
  'app.org.delete.confirm.send.resend': '重新傳送驗證',
  'app.org.delete.confirm.resend': '重新傳送',
  'app.org.delete.confirm.rule': '請輸入正確驗證碼',
  'app.org.delete.success': '刪除成功',
  'app.org.delete.balance': '該組織存在餘額，無法刪除',
};
